define('viewmodels/pages/cash/deposit',[
    'knockout',
    'underscore',
    'bluebird',
    'viewmodels/pages/cash/ChooseMethodViewModel',
    'viewmodels/modals/dialogs/ViewModelDialog'
], function (ko, _, Promise, ChooseMethodViewModel, ViewModelDialog) {

    function DepositViewModel(
        session,
        navigation,
        chooseValuableViewModel,
        CancelPendingWithdrawalsViewModel,
        PlayOkLimitsReachedViewModel,
        paymentMethods,
        depositMethodViewModelFactory,
        cashTabs,
        getField,
        depositModel,
        dialog,
        ChooseDepositValuableDialog,
        showError,
        PaymentWizard
    ) {

        var player = session.getAssociatedPlayer();

        this.topBarAction = ko.observable();

        var depositMethodViewModel = depositMethodViewModelFactory(
            depositModel,
            _.partial(
                PaymentWizard,
                navigation,
                navigation.ROUTES.DEPOSIT_SUCCESS,
                navigation.ROUTES.DEPOSIT_FAILURE,
                getField,
                depositModel,
                this.topBarAction,
                null,
                showError
            )
        );

        var chooseMethodViewModel = new ChooseMethodViewModel(
            'views/pages/cash/chooseMethod.html',
            ko.pureComputedArray(function() {

                var savedMethods = player.payments.usableDepositMethods(),
                    availableMethods = _.filter(paymentMethods.availableDepositMethods(), function(method) {
                        return player.payments.canCreateMoreUsableMethodInstancesOfType(method.type)() && method.canCreateDeposit();
                    });

                return savedMethods.concat(
                    availableMethods.map(function(availableMethod) {
                        return player.payments.makeNewUsableMethod(availableMethod);
                    })
                );

            }),
            depositModel.playerPaymentMethod,
            function() {
                // delaying here so we let the underlying payment method view to render before we close the dialog
                _.delay(chooseMethodDialog.close.bind(chooseMethodDialog), 100);
            }
        );
        chooseMethodViewModel.title = getField('choose_method_page_title');

        var chooseMethodDialog = new ViewModelDialog(dialog, chooseMethodViewModel, getField('choose_method_dialog_title'));

        var cancelPendingWithdrawalsViewModel = new CancelPendingWithdrawalsViewModel(player.payments.pendingWithdrawTransactions);

        this.subNav = cashTabs;

        this.meta = {
            title: getField('meta_title'),
            description: getField('meta_description')
        };

        this.depositBonus = player.depositBonus;

        this.activeViewModel = ko.pureComputed(function () {
            // TODO - play ok limit model and pending withdrawal reminder model needed in this flow
            var depositBonus = player.depositBonus;

            // if the player has a pending withdrawal, first offer to cancel them unless the player has chosen to ignore
            if (player.payments.hasPendingWithdraws() && !cancelPendingWithdrawalsViewModel.ignorePendingWithdrawals()) {

                return cancelPendingWithdrawalsViewModel;
            }

            else if (player.payments.availableToDeposit() <= 0 ||
                (depositModel.minAmount() && player.payments.availableToDeposit() < depositModel.minAmount())) {

                return new PlayOkLimitsReachedViewModel(player, depositModel.playerPaymentMethod);
            }

            // if the player has deposit bonuses, no active deposit bonus, and has not already made this decision
            else if (depositBonus.hasDepositBonusItems() &&
                !depositBonus.ignoreDepositBonusItem() &&
                !depositBonus.hasActiveEarnedDepositBonusItem()) {

                return chooseValuableViewModel;
            }
            // if the player has not got a saved deposit method
            else if (!depositModel.playerPaymentMethod()) {

                return chooseMethodViewModel;
            }

            return depositMethodViewModel();

        // @todo dhowlett This won't be needed after your PR is merged. Get on with it!
        }).extend({ rateLimit: 0 });

        this.selectedPaymentMethodName = ko.pureComputed(function () {

            var playerPaymentMethod = depositModel.playerPaymentMethod();

            if (playerPaymentMethod) {
                return playerPaymentMethod.identifier() || playerPaymentMethod.name();
            }

        });

        this.selectedPaymentMethodImage = ko.pureComputed(function() {

            var playerPaymentMethod = depositModel.playerPaymentMethod();

            if (playerPaymentMethod) {
                return playerPaymentMethod.specificMethod().imageUrl();
            }

        });

        this.chooseMethod = function() {
            chooseMethodDialog.show();
        };

        this.selectValuable = function() {
            dialog.showDialog(new ChooseDepositValuableDialog());
        };

        this.activate = function() {
            // when we activate the view, set the default selected method to be the last used method
            depositModel.playerPaymentMethod(player.payments.usableDepositMethods()[0]);
        };

        this.canActivate = function() {
            return paymentMethods.load(true).then(function(result) {
                return result === 'LOADED';
            });
        };

        this.onSuccess = function(routeInfo) {
            depositModel.notifySuccessfulReturn(routeInfo.queryParams.data);
            return navigation.reverseRoute( navigation.ROUTES.GAMES_TOP );
        };

        this.onFailure = function() {
            showError();
        };
    }

    return DepositViewModel;
});

